import React from "react";

export function MetadataActionFooter({
  onSave,
  canSave,
  isSaving,
  isDirty,
  errorMessage,
  successMessage,
  showSaveButton = true
}: {
  onSave: () => void;
  canSave: boolean;
  isSaving: boolean;
  isDirty: boolean;
  errorMessage: string | null;
  successMessage: string | null;
  showSaveButton?: boolean;
}): JSX.Element {
  return (
    <section className="tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-slate-50 tw-p-4">
      {isSaving ? (
        <p className="tw-mb-2 tw-flex tw-items-center tw-gap-2 tw-text-xs tw-font-semibold tw-text-slate-600">
          <span className="tw-inline-block tw-h-3 tw-w-3 tw-animate-spin tw-rounded-full tw-border-2 tw-border-slate-300 tw-border-t-slate-700" />
          Saving changes. Waiting for API response...
        </p>
      ) : null}
      {errorMessage ? (
        <p className="tw-mb-2 tw-text-xs tw-font-semibold tw-text-rose-500">{errorMessage}</p>
      ) : null}
      {successMessage ? (
        <p className="tw-mb-2 tw-text-xs tw-font-semibold tw-text-emerald-600">
          {successMessage}
        </p>
      ) : null}
      <div className="tw-flex tw-flex-col tw-gap-2 sm:tw-flex-row sm:tw-items-start sm:tw-justify-between">
        <div className="tw-order-1 sm:tw-order-1 sm:tw-flex-1" />
        {showSaveButton ? (
          <div className="tw-order-2 tw-flex tw-flex-col tw-items-end tw-gap-2 sm:tw-order-2">
            <button
              type="button"
              onClick={onSave}
              disabled={!canSave || isSaving}
              className="tw-w-full tw-rounded-full tw-border tw-border-[#03234a] tw-bg-[#03234a] tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-60 hover:tw-bg-[#021b39] sm:tw-w-auto sm:tw-min-w-[12rem]"
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        ) : null}
      </div>
    </section>
  );
}
